import { render, staticRenderFns } from "./GPFSEvent.vue?vue&type=template&id=d8fd67d4&"
import script from "./GPFSEvent.vue?vue&type=script&lang=js&"
export * from "./GPFSEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports